import { render, staticRenderFns } from "./TranUserPackageView.vue?vue&type=template&id=1e916be8&scoped=true"
import script from "./TranUserPackageView.vue?vue&type=script&lang=js"
export * from "./TranUserPackageView.vue?vue&type=script&lang=js"
import style0 from "./TranUserPackageView.vue?vue&type=style&index=0&id=1e916be8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e916be8",
  null
  
)

export default component.exports